import { render, staticRenderFns } from "./FormFpostgradcreate.vue?vue&type=template&id=9d6f5cf2&"
import script from "./FormFpostgradcreate.vue?vue&type=script&lang=js&"
export * from "./FormFpostgradcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports